<template>
  <div class="container">
    <common-search-form-wrapper :hiddenExpand="true" :reset="handleResetSearch">
      <el-form size="mini" :model="searchInfo" label-width="64px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="提现时间:" prop="create_time">
              <common-date-range-selector
                v-model="searchInfo.create_time"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleSearch"
                value-format="timestamp"
                :picker-options="effectiveDate"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="提现流水:" prop="draw_no">
              <el-input
                v-model="searchInfo.draw_no"
                placeholder="请输入提现流水"
                @change="handleSearch"
                clearable
                maxlength="120"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="完成时间:" prop="complete_time">
              <el-date-picker
                v-model="searchInfo.complete_time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleSearch"
                value-format="timestamp"
                :picker-options="effectiveDate"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="提现类型:" prop="withdrawal_method">
              <el-radio-group
                v-model="searchInfo.withdrawal_method"
                @change="handleSearch"
              >
                <el-radio-button :label="-1">全部</el-radio-button>
                <el-radio-button :label="1">手动提现</el-radio-button>
                <el-radio-button :label="2">自动提现</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="状态:" prop="status">
              <el-radio-group
                v-model="searchInfo.status"
                @change="handleSearch"
              >
                <el-radio-button :label="-1">全部</el-radio-button>
                <el-radio-button :label="1">提现中</el-radio-button>
                <el-radio-button :label="2">提现成功</el-radio-button>
                <el-radio-button :label="3">提现失败</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <div style="margin-bottom: 12px">
      <div
        class="mwow-button-filled primary"
        @click="handleExport"
        v-debounce="1000"
      >
        导出
      </div>
    </div>
    <el-table
      class="mwow-table"
      v-horizontal-scroll
      size="mini"
      :data="tableData"
      stripe
      style="width: 100%"
      tooltip-effect="dark"
      @sort-change="handleSortChange"
      :default-sort="{
        order: 'descending',
        prop: 'create_time',
      }"
    >
      <el-table-column
        label="提现时间"
        prop="create_time"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
      ></el-table-column>
      <el-table-column label="提现银行卡">
        <template slot-scope="scope">
          <div v-if="scope.row.status === 3">-</div>
          <div v-else>
            <p>{{ scope.row.acct_name }}</p>
            <p>{{ scope.row.acct_no }}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="提现类型" prop="withdrawal_method">
        <template slot-scope="scope">
          {{ scope.row.withdrawal_method === 1 ? "手动提现" : "自动提现" }}
        </template>
      </el-table-column>
      <el-table-column
        label="提现金额(元)"
        prop="draw_amount"
      ></el-table-column>
      <el-table-column
        label="手续费(元)"
        prop="draw_fee_amount"
      ></el-table-column>
      <el-table-column label="实际到账金额" prop="draw_real_amount">
        <template slot-scope="scope">
          <div v-if="scope.row.status === 2">
            {{ scope.row.draw_real_amount }}
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column label="完成时间" prop="complete_time"></el-table-column>
      <el-table-column label="状态" prop="status">
        <template slot-scope="scope">
          <span v-show="scope.row.status === 1">提现中</span>
          <span v-show="scope.row.status === 2">提现成功</span>
          <span v-show="scope.row.status === 3">提现失败</span>
        </template>
      </el-table-column>
      <el-table-column label="提现流水" prop="draw_no"></el-table-column>
      <el-table-column label="操作人" prop="staff.name">
        <template slot-scope="scope">
          {{ scope.row.staff ? scope.row.staff.name : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="result_msg">
        <template slot-scope="scope">{{
          scope.row.result_msg || "-"
        }}</template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
  </div>
</template>
<script>
import { exportLoop } from "@/utils/export";
import { dateFormat } from "@/utils/timeFormat";
import { getWithdrawLogApi, exportWithdrawLogApi } from "@/api/storeWallet";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";
import CommonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
export default {
  props: ["visible"],
  components: {
    commonDateRangeSelector,
    CommonSearchFormWrapper,
  },
  data() {
    return {
      searchInfo: {
        sort_field: "create_time",
        sort_type: "desc",
        create_time: [],
        draw_no: "",
        status: -1,
        complete_time: [],
        withdrawal_method: -1,
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      // 未来时间应不可选
      effectiveDate: {
        disabledDate(date) {
          return date.getTime() > Date.now();
        },
      },
    };
  },
  created() {
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.handleSearch();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.handleSearch();
    }
  },
  methods: {
    handleResetSearch() {
      this.searchInfo = {
        sort_field: "create_time",
        sort_type: "desc",
        create_time: [],
        draw_no: "",
        status: -1,
        complete_time: [],
        withdrawal_method: -1,
      };
      this.handleSearch();
    },
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handleSortChange(e) {
      if (e.order == "descending") {
        this.searchInfo.sort_type = "desc";
      } else if (e.order == "ascending") {
        this.searchInfo.sort_type = "asc";
      } else {
        this.searchInfo.sort_type = "";
      }
      this.handleSearch();
    },
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
        sort_field: "create_time",
        sort_type: this.searchInfo.sort_type,
      };
      if (
        this.searchInfo.create_time &&
        this.searchInfo.create_time.length === 2
      ) {
        option.create_time_start = String(
          this.searchInfo.create_time[0] / 1000
        );
        option.create_time_end = String(
          this.searchInfo.create_time[1] / 1000 + 24 * 60 * 60 - 1
        );
      }
      if (this.searchInfo.draw_no) {
        option.draw_no = this.searchInfo.draw_no;
      }
      if (this.searchInfo.status >= 0) {
        option.status = this.searchInfo.status;
      }
      if (
        this.searchInfo.complete_time &&
        this.searchInfo.complete_time.length === 2
      ) {
        option.complete_time_start = String(
          this.searchInfo.complete_time[0] / 1000
        );
        option.complete_time_end = String(
          this.searchInfo.complete_time[1] / 1000 + 24 * 60 * 60 - 1
        );
      }
      if (this.searchInfo.withdrawal_method >= 0) {
        option.withdrawal_method = this.searchInfo.withdrawal_method;
      }
      getWithdrawLogApi(option).then((res) => {
        this.page = res.data.page;
        this.total = res.data.total;
        res.data.list.map((item) => {
          item.create_time =
            item.create_time === 0
              ? "-"
              : dateFormat("YYYY-mm-dd HH:MM", item.create_time * 1000);
          item.complete_time =
            item.complete_time === 0
              ? "-"
              : dateFormat("YYYY-mm-dd HH:MM", item.complete_time * 1000);
        });
        this.tableData = res.data.list;
      });
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    handleExport() {
      const option = {
        sort_field: "create_time",
        sort_type: this.searchInfo.sort_type,
      };
      if (
        this.searchInfo.create_time &&
        this.searchInfo.create_time.length >= 0
      ) {
        option.create_time_start = this.searchInfo.create_time[0] / 1000;
        option.create_time_end =
          this.searchInfo.create_time[1] / 1000 + 24 * 60 * 60 - 1;
      } else {
        return this.$message.warning({
          message: "导出必须选定时间范围且不能超过一年",
        });
      }
      if (this.searchInfo.draw_no) {
        option.draw_no = this.searchInfo.draw_no;
      }
      if (this.searchInfo.status >= 0) {
        option.status = this.searchInfo.status;
      }
      if (
        this.searchInfo.complete_time &&
        this.searchInfo.complete_time.length >= 0
      ) {
        option.complete_time_start = this.searchInfo.complete_time[0] / 1000;
        option.complete_time_end =
          this.searchInfo.complete_time[1] / 1000 + 24 * 60 * 60 - 1;
      }
      if (this.searchInfo.withdrawal_method >= 0) {
        option.withdrawal_method = this.searchInfo.withdrawal_method;
      }
      exportWithdrawLogApi(option).then((res) => {
        exportLoop(res.data.task_id);
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
